module.exports = __webpack_public_path__ + "assets/waterMeterIcon4.daa0fde8.svg";